export default {
  presenter: 'sika',
  title: 'i3 - tiling window manager',
  subtitle: 'začátečníci',
  text: `
Ukazka mocneho grafickeho prostredi pro vyssi produktivitu plne ovladatelneho z klavesnice.
Ukazeme si jak jej nainstalovat, nakonfigurovat a pouzivat.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/sika-i3.js